import { OrderDetailsResponse } from "../../../../../services/api/admin-order.types";

interface OrderDetailsHeaderProps {
    order: OrderDetailsResponse;
}

const OrderDetailsHeader: React.FC<OrderDetailsHeaderProps> = ({ order }) => {
    const formatDate = (dateString: string) =>
        new Date(dateString).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });

    return (
        <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl border border-slate-200 p-4 mb-5">
            <h3 className="text-sm font-bold text-slate-800 mb-3">Patient Details</h3>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-xs">
                {/* Invoice Number */}
                <div>
                    <div className="text-slate-400 font-semibold mb-1 text-[0.65rem] uppercase tracking-wide">Invoice Number</div>
                    <div className="text-slate-800 font-bold">{order.orderNumber}</div>
                </div>
                {/* Order Date */}
                <div>
                    <div className="text-slate-400 font-semibold mb-1 text-[0.65rem] uppercase tracking-wide">Order Date</div>
                    <div className="text-slate-800 font-bold">{formatDate(order.orderDate)}</div>
                </div>
                {/* Ordered By */}
                <div>
                    <div className="text-slate-400 font-semibold mb-1 text-[0.65rem] uppercase tracking-wide">Ordered By</div>
                    <div className="flex items-center gap-2">
                        {order.patientImage && (
                            <img src={order.patientImage} alt="" className="w-7 h-7 rounded-full object-cover border border-slate-200" />
                        )}
                        <div>
                            <div className="text-slate-800 font-bold">{order.patientName}</div>
                            <div className="text-slate-400 text-[0.6rem]">+91 {order.patientPhone}</div>
                        </div>
                    </div>
                </div>
                {/* Ordered For */}
                <div>
                    <div className="text-slate-400 font-semibold mb-1 text-[0.65rem] uppercase tracking-wide">Ordered For</div>
                    <div className="flex items-center gap-2">
                        {order.orderForImage && (
                            <img src={order.orderForImage} alt="" className="w-7 h-7 rounded-full object-cover border border-slate-200" />
                        )}
                        <div>
                            <div className="text-slate-800 font-bold">{order.orderedForName}</div>
                            <div className="text-slate-400 text-[0.6rem]">+91 {order.orderedForPhone}</div>
                        </div>
                    </div>
                </div>
                {/* Clinic */}
                <div>
                    <div className="text-slate-400 font-semibold mb-1 text-[0.65rem] uppercase tracking-wide">Clinic</div>
                    <div>
                        <div className="text-slate-800 font-bold">{order.clinicName}</div>
                        <div className="text-slate-400 text-[0.6rem]">+91 {order.clinicPhone}</div>
                    </div>
                </div>
            </div>

            {/* Address */}
            <div className="mt-3 pt-3 border-t border-slate-200">
                <div className="text-slate-400 font-semibold mb-1 text-[0.65rem] uppercase tracking-wide">Delivery Address</div>
                <div className="text-xs text-slate-700">
                    {order.address}, {order.city}, {order.state} - {order.pincode}
                </div>
            </div>
        </div>
    );
};

export default OrderDetailsHeader;
